import { render, staticRenderFns } from "./DetailGangguanAsetPage.vue?vue&type=template&id=a6353cf8"
import script from "./DetailGangguanAsetPage.vue?vue&type=script&lang=js"
export * from "./DetailGangguanAsetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports